const translationKeys = {
  HOME_HEADER_TITLE: "home.header.title",
} as const;

export default translationKeys;

export type TranslationKey =
  (typeof translationKeys)[keyof typeof translationKeys];
